// Plain JS only (NO JSX, NO hooks)

const appRoutes = [
  { path: "/", sitemap: true },
  { path: "/event", sitemap: true },
  { path: "/contact", sitemap: true },
  { path: "/about", sitemap: true },
  { path: "/admission", sitemap: true },
  { path: "/feestructure", sitemap: true },
  { path: "/profile", sitemap: false },        // ❌ private
  { path: "/notice", sitemap: true },
  { path: "/event-details", sitemap: true },
  { path: "/circular", sitemap: true },
  { path: "/principalmessage", sitemap: true },
  { path: "/aboutcollege", sitemap: true },
  { path: "/mission", sitemap: true },
  { path: "/vision", sitemap: true },
  { path: "/missionvision", sitemap: true },
  { path: "/syllabus", sitemap: true },
  { path: "/courses", sitemap: true },
{
  path: "*",
  sitemap: false,
},
  // ❌ dynamic routes excluded from sitemap
  { path: "/courses/:slug", sitemap: false },
];

export default appRoutes;
